import { getOAuthConnectedClients, type OAuthClientResponse } from "../oauth";
import { queryKeys } from "../queryKeys";
import { type QueryOptions, useRequest } from "./useRequest";

export const useGetOAuthConnectedClients = ({
  accountId = "",
  options,
}: {
  accountId?: string;
  options?: QueryOptions<OAuthClientResponse[]>;
}) => {
  const fetchOAuthConnectedClients = async () => {
    return await getOAuthConnectedClients(accountId);
  };

  const { data, refetch } = useRequest(
    queryKeys.oauth.connectedClients(accountId),
    fetchOAuthConnectedClients,
    {
      gcTime: 9999999,
      staleTime: Infinity,
      ...options,
    },
  );

  return { clients: data, refetch };
};
